import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber7 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8854 5.0045-2.6924 6.627h-1.4961l2.6924-6.5h-2.75v1.23h-1.2422v-2.4156h5.4883z" />
    </g>
  );
};

export default withIcon(IconNumber7);
